import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import { useCart } from '../context/CartContext';

function Cart() {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();

  const handleQuantityChange = (productId, newQuantity) => {
    if (newQuantity >= 1) {
      updateQuantity(productId, newQuantity);
    }
  };

  const handleCheckout = () => {
    navigate('/checkout');
  };

  if (cartItems.length === 0) {
    return (
      <>
        <Helmet>
          <title>Καλάθι Αγορών - Ferupen Barbershop</title>
          <meta name="description" content="Το καλάθι αγορών σας" />
        </Helmet>
        <div className="cart-container">
          <div className="empty-cart">
            <div className="empty-cart-icon">
              <FaShoppingCart />
            </div>
            <h1>Το Καλάθι σας είναι Άδειο</h1>
            <p>Δεν έχετε προσθέσει ακόμα προϊόντα στο καλάθι σας.</p>
            <Link to="/" className="continue-shopping-btn">
              Συνέχεια Αγορών
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Καλάθι Αγορών - Ferupen Barbershop</title>
        <meta name="description" content="Ελέγξτε το καλάθι αγορών σας" />
      </Helmet>

      <div className="cart-container">
        <h1>Το Καλάθι σας</h1>

        <div className="cart-items">
          {cartItems.map(item => (
            <div key={item.id} className="cart-item">
              <img 
                src={item.image} 
                alt={item.name} 
                className="cart-item-image"
              />
              
              <div className="cart-item-details">
                <h3>{item.name}</h3>
                <p className="cart-item-price">Τιμή: €{item.price.toFixed(2)}</p>
                
                <div className="cart-item-quantity">
                  <label>Ποσότητα:</label>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) => handleQuantityChange(item.id, parseInt(e.target.value))}
                  />
                </div>
                
                <button 
                  onClick={() => removeFromCart(item.id)}
                  className="remove-btn"
                >
                  Αφαίρεση
                </button>
              </div>

              <div className="cart-item-total">
                <p>Σύνολο:</p>
                <p className="total-price">€{(item.price * item.quantity).toFixed(2)}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="cart-summary">
          <h2>Σύνοψη Παραγγελίας</h2>
          <div className="summary-row">
            <span>Υποσύνολο:</span>
            <span>€{getCartTotal().toFixed(2)}</span>
          </div>
          <div className="summary-row">
            <span>Έξοδα Αποστολής:</span>
            <span>€5.00</span>
          </div>
          <div className="summary-row total">
            <span>Σύνολο:</span>
            <span>€{(getCartTotal() + 5).toFixed(2)}</span>
          </div>
          
          <button onClick={handleCheckout} className="checkout-btn">
            Ολοκλήρωση Παραγγελίας
          </button>
          
          <Link to="/" className="continue-shopping-btn" style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}>
            Συνέχεια Αγορών
          </Link>
        </div>
      </div>
    </>
  );
}

export default Cart;